import React from 'react'

import ForgotPassword from '../components/Auth/ForgotPassword/ForgotPassword'

const ForgotPasswordPage = () => {
  return <ForgotPassword />
}

export default ForgotPasswordPage
